export enum AppRouteSegments {
  root = '',
  applications = 'applications'
}
